export default __webpack_public_path__ + "static/media/img_upload_edit.3be7824b.jpg";